import { Box, Paper, Typography, Table, TableHead, TableRow, TableBody } from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
} from '../../../../common/components';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
} from 'recharts';

const formatDate = (value) => {
  if (!value) return '-';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleDateString('es-AR');
};

const formatDateTime = (value) => {
  if (!value) return '-';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleString('es-AR');
};

const HistoricalProgressChart = ({ timeline, entries, isLoading }) => {
  if (isLoading) {
    return (
      <Paper sx={{ p: 3 }}>
        <Typography variant="body2" color="text.secondary">
          Cargando avance histórico...
        </Typography>
      </Paper>
    );
  }

  if (!Array.isArray(timeline) || timeline.length === 0) {
    return (
      <Paper sx={{ p: 3 }}>
        <Typography variant="body2" color="text.secondary">
          No hay historial de avance para el proyecto seleccionado.
        </Typography>
      </Paper>
    );
  }

  return (
    <Box sx={{ display: 'grid', gap: 2 }}>
      <Paper sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Avance progresivo por fecha
        </Typography>
        <Box sx={{ width: '100%', height: 360 }}>
          <ResponsiveContainer>
            <LineChart data={timeline} margin={{ top: 20, right: 20, left: 10, bottom: 20 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" tickFormatter={formatDate} />
              <YAxis domain={[0, 100]} />
              <RechartsTooltip
                labelFormatter={(value) => formatDate(value)}
                formatter={(value, name) => {
                  if (name === 'project_total_current_percentage') {
                    return [`${Number(value).toFixed(2)}%`, 'Avance total'];
                  }
                  if (name === 'updates_count') {
                    return [value, 'Actualizaciones'];
                  }
                  return [value, name];
                }}
              />
              <Line
                type="monotone"
                dataKey="project_total_current_percentage"
                stroke="#1976d2"
                strokeWidth={3}
                dot={{ r: 4 }}
                activeDot={{ r: 6 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </Box>
      </Paper>

      <GeneralTableBox>
        <Table>
          <TableHead>
            <TableRow>
              <HeadTableCell wmd="25%">Fecha</HeadTableCell>
              <HeadTableCell wmd="30%">Tarea</HeadTableCell>
              <HeadTableCell wmd="15%">Anterior</HeadTableCell>
              <HeadTableCell wmd="15%">Nuevo</HeadTableCell>
              <HeadTableCell wmd="15%">Delta</HeadTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {entries.length > 0 ? (
              entries.map((entry) => (
                <TableRow key={entry.uuid}>
                  <RowTableCell>{formatDateTime(entry.created_at)}</RowTableCell>
                  <RowTableCell>{entry.task_name || '-'}</RowTableCell>
                  <RowTableCell>{Number(entry.previous_percentage || 0).toFixed(2)}%</RowTableCell>
                  <RowTableCell>{Number(entry.new_percentage || 0).toFixed(2)}%</RowTableCell>
                  <RowTableCell>{Number(entry.delta_percentage || 0).toFixed(2)}%</RowTableCell>
                </TableRow>
              ))
            ) : (
              <NoDataSkeleton colSpan={5} message="Sin movimientos de avance" />
            )}
          </TableBody>
        </Table>
      </GeneralTableBox>
    </Box>
  );
};

export default HistoricalProgressChart;
